import React from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";

const ProductFilter = ({
  options = [],
  value = [],
  onChange,
  loading,
  sx = {},
}) => {
  const renderValue = (selected = []) => {
    if (!selected.length) return null;
    const first = selected[0]?.label || "";
    const extra = selected.length - 1;
    return (
      <Chip
        size="small"
        label={extra > 0 ? `${first} +${extra}` : first}
        sx={{ maxWidth: "100%" }}
      />
    );
  };

  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={1}
      renderTags={(selected) => renderValue(selected)}
      sx={{
        ...sx,
        "& .MuiAutocomplete-inputRoot": {
          flexWrap: "nowrap",
        },
      }}
      options={options}
      value={value}
      onChange={(_, next) => onChange(next)}
      loading={loading}
      getOptionLabel={(opt) => opt?.label || ""}
      isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
      renderInput={(params) => <TextField {...params} label="Products" />}
    />
  );
};

export default ProductFilter;
